<template>
  <table class="table">
    <thead>
      <slot name="columns" v-if="hasHeader != 'false'">
        <tr>
          <th v-for="column in columns" :key="column">{{ column }}</th>
        </tr>
      </slot>
    </thead>
    <tbody>
      <tr v-for="(item, index) in data" :key="index">
        <slot :row="item">
            <td v-for="column in columns" :key="column" >
              <span v-if="hasValue(item, column)">
                {{ itemValue(item, column) }}
              </span>
            </td>
        </slot>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  name: 'l-table',
  props: {
    columns: Array,
    data: Array,
    hasHeader: {
      type: String,
      default: "true"
    }
  },
  methods: {
    hasValue(item, column) {
      return item[column.toLowerCase()] !== 'undefined'
    },
    itemValue(item, column) {
      return item[column.toLowerCase()]
    }
  }
}
</script>
<style></style>
